import React, { useState, useEffect } from "react";
import HrDashboardFilters from "./HrDashboardFilters";
import "../Styling/Hr_Dashboard.css";
import AttendanceSummary from "./AttendanceSummary";
import EmployeeDistribution from "./EmployeeDistribution";
import UpcomingHolidays from "./UpcomingHolidays";
import NewsSection from "./NewsSection";
import PunchInMaster from "./PunchInMaster";
import PastAttendance from "./PastAttendance";
import WorkHours from "./WorkHours";
import UpcomingLeaves from "./UpcomingLeaves";
import SalaryOverview from "./SalaryOverview";
import EmployeeGrowthTrend from "./EmployeeGrowthTrend.jsx";
import PlannedLeaves from "./PlannedLeaves.jsx";
import TodayLeaves from "./TodayLeaves.jsx";
import { UserCog } from "lucide-react";
import Notifications from "./NotificationComponent.jsx";
import TeamDetails from "./TeamDetails.jsx";
import ShimmerDashboard from "./ShimmerDashboard";

  const HrDashboard = () => {
  const currentYear = new Date().getFullYear();
  const [filters, setFilters] = useState({
    orgId: "",
    companyCode: "",
    fiscalYear: currentYear
  });
  const [loading, setLoading] = useState(true);
  const ShimmerOverlay = () => {
  return (
    <div className="shimmer-overlay">
      <ShimmerDashboard />
    </div>
  );
};

    useEffect(() => {
    // simulate API load
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
    
  return (
    <div className="container-fluid py-4 hr-dashboard-page">
         {loading && <ShimmerOverlay />}

         <div className={`dashboard-content ${loading ? "blur-content" : ""}`}>
      <div className="hr-analytics mb-3">
        <h1>HR Analytics Dashboard</h1>
      </div>

      {/* Filters */}
      <HrDashboardFilters
        onFilterChange={setFilters}
        initialFilters={filters}
      />

      <div className="row g-3 mt-3">

        {/* HR PERSONAL */}
        <div className="col-lg-4 col-md-12 gap-3">
<div className="hr-personal-panel">
  <div className="panel-header">
    <div className="header-left">
      <div className="panel-icon">
        <UserCog size={18} />
      </div>
      <h6>HR Personal</h6>
    </div>
  </div>

  {/* ✅ ADD THIS WRAPPER */}
  <div className="hr-personal-content">
    <PunchInMaster filters={filters} />
    <PastAttendance filters={filters} />
    <WorkHours filters={filters} />
    <UpcomingLeaves filters={filters} />
  </div>
</div>
        </div>

        {/* HR WORKSPACE */}
        <div className="col-lg-8 col-md-12">
          <div className="row g-3">
            <div className="col-md-6">
              <AttendanceSummary filters={filters} />
            </div>

            <div className="col-md-6">
              <UpcomingHolidays filters={filters} />
            </div>

            <div className="col-12">
              <EmployeeDistribution filters={filters} />
            </div>

            <div className="col-md-6">
              <NewsSection filters={filters} />
            </div>

            <div className="col-md-6">
              <SalaryOverview filters={filters} />
            </div>

            <div className="col-md-6">
              <PlannedLeaves filters={filters} />
            </div>

            <div className="col-md-6">
              <TodayLeaves filters={filters} />
            </div>
            <div className="col-md-6">
            <Notifications/>
            </div>
            <div className="col-md-6">
            <TeamDetails/>
            </div>
          </div>
        </div>

        <div className="col-12 mt-3">
          <EmployeeGrowthTrend filters={filters} />
        </div>
      </div>
      </div>
    </div>
  );
};

export default HrDashboard;
